// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"contentWrapper--3Qfma","header":"header--X580A"};